<template>
	<div class="card-inner">
		<div class="alert alert-info">
			<strong>{{ $t('comp_global_title') }}</strong><br />
			{{ $t('comp_global_description') }}
		</div>

		<table class="table table-sm">
			<thead>
				<tr>
					<th>{{ $t('comp_global_chapter') }}</th>
					<th style="text-align: center">{{ $t('comp_global_new_page') }}</th>
					<th style="text-align: center">{{ $t('comp_global_hide_page') }}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="chapter in chapterList" :key="chapter.id">
					<td>
						<strong>{{ chapter.cap }}</strong> - {{ $t(chapter.titleKey) }}
					</td>
					<td style="text-align: center">
						<div class="custom-control custom-checkbox">
							<input
								type="checkbox"
								class="custom-control-input"
								:id="'newpage-' + chapter.id"
								v-model="chapter.settings.newpage"
							/>
							<label
								class="custom-control-label"
								:for="'newpage-' + chapter.id"
							></label>
						</div>
					</td>
					<td style="text-align: center">
						<div class="custom-control custom-checkbox">
							<input
								type="checkbox"
								class="custom-control-input"
								:id="'hide-' + chapter.id"
								v-model="chapter.settings.hideProgressBar"
							/>
							<label
								class="custom-control-label"
								:for="'hide-' + chapter.id"
							></label>
						</div>
					</td>
					<td style="text-align: right">
						<button
							class="btn btn-sm btn-primary"
							@click="saveChapterSetting(chapter)"
						>
							{{ $t('common_save') }}
						</button>
					</td>
				</tr>
			</tbody>
		</table>

		<div style="margin-top: 20px">
			<button class="btn btn-lg btn-primary" @click="saveAllSettings">
				{{ $t('comp_global_save_all') }}
			</button>
		</div>
	</div>
</template>

<script>
import {
	getGlobalChapterSettings,
	saveGlobalChapterSettings,
} from '@/services/reporting-v3.service';

export default {
	name: 'GlobalChapterSettings',
	data() {
		return {
			chapterList: [
				{
					cap: 'A',
					id: 'inspectionDetails',
					titleKey: 'comp_global_ch_inspection_details',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B',
					id: 'general',
					titleKey: 'comp_global_ch_general',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.1',
					id: 'generalB1',
					titleKey: 'comp_global_ch_general_b1',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.2',
					id: 'generalB2',
					titleKey: 'comp_global_ch_general_b2',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.3',
					id: 'generalB3',
					titleKey: 'comp_global_ch_general_b3',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.4',
					id: 'generalB4',
					titleKey: 'comp_global_ch_general_b4',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.5',
					id: 'generalB5',
					titleKey: 'comp_global_ch_general_b5',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'C',
					id: 'machinedata',
					titleKey: 'comp_global_ch_machine_data',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'D',
					id: 'components',
					titleKey: 'comp_global_ch_components',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'E',
					id: 'findings',
					titleKey: 'comp_global_ch_findings',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'F',
					id: 'conclusion',
					titleKey: 'comp_global_ch_conclusion',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'G',
					id: 'disclaimer',
					titleKey: 'comp_global_ch_disclaimer',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
			],
			loading: false,
		};
	},
	methods: {
		async loadGlobalSettings() {
			try {
				const response = await getGlobalChapterSettings();

				if (response && response.data && response.data.settings) {
					// Merge loaded settings with chapter list
					for (const chapter of this.chapterList) {
						const savedSetting = response.data.settings.find(
							(s) => s.chapterId === chapter.id
						);
						if (savedSetting && savedSetting.settings) {
							chapter.settings = {
								...chapter.settings,
								...savedSetting.settings,
							};
						}
					}
				}
			} catch (error) {
				console.error('Error loading global settings:', error);
				// Continue with default settings
			}
		},

		async saveChapterSetting(chapter) {
			this.loading = true;
			try {
				await saveGlobalChapterSettings(chapter.id, chapter.settings);

				this.$swal(this.$t('comp_global_swal_success'), this.$t('comp_global_swal_chapter_saved'), 'success');
			} catch (error) {
				console.error('Error saving setting:', error);
				this.$store.dispatch('api_error', error);
			}
			this.loading = false;
		},

		async saveAllSettings() {
			this.loading = true;

			try {
				const promises = this.chapterList.map((chapter) =>
					saveGlobalChapterSettings(chapter.id, chapter.settings)
				);

				await Promise.all(promises);

				this.$swal(
					this.$t('comp_global_swal_success'),
					this.$t('comp_global_swal_all_saved'),
					'success'
				);
			} catch (error) {
				console.error('Error saving settings:', error);
				this.$store.dispatch('api_error', error);
			}

			this.loading = false;
		},
	},

	mounted() {
		this.loadGlobalSettings();
	},
};
</script>

<style scoped>
.custom-control-label {
	cursor: pointer;
}

.table td {
	vertical-align: middle;
}
</style>
